<summa-details-tile-widget
  [title]="'reseller:notifications.widget.title' | i18nextCap"
  [counters]="sandbox.notificationCounters$ | async"
  [route]="{ destination: ['notifications'], tooltip: 'common:dictionary.view-all' | i18nextCap }"
  [totalCountLabel]="'project:notification-widget.total-count-in-last-24-hours' | i18nextCap"
></summa-details-tile-widget>
